import { render, staticRenderFns } from "./AccessProvider.vue?vue&type=template&id=56779c43"
import script from "./AccessProvider.vue?vue&type=script&lang=js"
export * from "./AccessProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports